import React from 'react';
import { useTheme } from '@24i/nxg-sdk-higgs';
import { View, Text } from '@24i/nxg-sdk-quarks';
import PackshotGrid from '@24i/nxg-sdk-gluons/src/components/containers/PackshotGrid';
import Loader from '@24i/nxg-sdk-gluons/src/components/ui/Loader';
import { getTelegramWebApp } from '@24i/nxg-sdk-higgs/src/utils';
import { withWebHeader } from '@24i/nxg-sdk-smartott/src/navigation/components/withWebHeader';
import { WithWebHeaderProps } from '@24i/nxg-sdk-smartott/src/navigation/components/withWebHeader/types';

import getSeeAllScreenStyles from '../styles/index.web';
import { SeeAllScreenWebProps, SEE_ALL_TEST_IDS } from '../types';

const SeeAllScreen = ({
    assets,
    assetsLabel,
    styles: getStyles = getSeeAllScreenStyles,
    isLoading,
    gridContainerRef,
    displayType,
    handlePackshotPress,
}: SeeAllScreenWebProps & WithWebHeaderProps) => {
    const { theme } = useTheme();
    const styles = getStyles(theme);

    return (
        <View style={styles.holder} ref={gridContainerRef} testID={SEE_ALL_TEST_IDS.CONTAINER}>
            {!getTelegramWebApp() && (
                <View style={styles.pickerHolder}>
                    <Text style={styles.sectionTitle} testID={SEE_ALL_TEST_IDS.TITLE}>
                        {assetsLabel}
                    </Text>
                </View>
            )}
            {/* @ts-ignore */}
            <PackshotGrid
                items={assets}
                onItemPress={handlePackshotPress}
                displayType={displayType}
            />
            {isLoading && <Loader />}
        </View>
    );
};

export default withWebHeader(SeeAllScreen);
